import { Box, Button, IconButton, Tooltip, Typography, Chip, Stack, } from "@mui/material";
import Table, { ColumnType } from "components/Table";
import useTitle from "hooks/useTitle";
import { useEffect, useState } from "react";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { ResType } from "types";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { resetFilters } from "redux/reducers/taskboardSlice";
import { Add, Delete, Edit, Visibility } from "@mui/icons-material";
import {
  deleteFyaItem,
  exportClientproceedingFya,
  getClientproceedingFya,
  getFyaSections,
  getIncomeTaxProfileWithName,
} from "api/services/automation/income-tax";
import AccessDenied from "./Access/accessDenide";
import Loader from "components/Loader";
import { resetState } from "redux/reducers/clientsSlice";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import { getCurrentFormattedDateTime } from "utils";
import { handleError } from "utils/handleError";
import { snack } from "components/toast";
import ValidateAccess from "components/ValidateAccess";
import { Permissions } from "data/permissons";
import { useClientIncomeTax } from "./ClientIncomeTaxContext";
import CreateClientFya from "./createClientFya";
import excelIcon from "./../../assets/images/128px-Microsoft_Office_Excel_(2019–2025).svg.png";
import SearchContainer from "components/SearchContainer";
import { dropDownType, getAutFinancialYears } from "pages/atom-pro/constants";
import { StyledSpan } from "./styles";
import EditClientFya from "./fya/EditClientFya";
import { useConfirm } from "context/ConfirmDialog";
import { buildChips } from "pages/atom-pro/Filters/buildChips";
import FilterEngine from "pages/atom-pro/Filters";
import clearFilters from "./../../assets/images/clear-filter.svg";
import { hasActiveFilters } from "pages/atom-pro/Filters/components";
import moment from "moment";


const ClientEproceedingFya = (state) => {
  useTitle("ATOM Pro | Clients");
  const { data: clientDetails } = useClientIncomeTax();
  const staticCategory = { categoryId: 41 }
  const [page, setPage] = useState<number>(0);
  const [pageCount, setPageCount] = useState<number>(10);
  const [totalCount, setTotalCount] = useState<number>(0);
  const dispatch = useDispatch();
  const params = useParams();
  const [sections, setSectionData] = useState<any>(null);
  const [search, setSearch] = useState("");
  const [openCreate, setOpenCreate] = useState(false)

  const [filters, setFilters] = useState({
    section: null,
    assessmentYear: null,
    type: null
  });

  useEffect(() => {
    return () => {
      dispatch(resetFilters());
      dispatch(resetState());
    };
  }, []);

  const [checkAccess, setCheckAccess] = useState(true);

  const { data, isLoading }: ResType = useQuery(
    [
      "client-proceeding-fya",
      params.incometaxid,
      {
        limit: pageCount,
        offset: page * pageCount,
        search: search,
        ...filters
      },
    ],
    getClientproceedingFya,
    {
      onSuccess: (res) => {
        setTotalCount(res?.data?.count);
        setCheckAccess(res?.data?.accessDenied);
      },
    }
  );


  const handleSearch = (e) => {
    setSearch(e);
    setPage(0);
  };

  const { data: sectionData, isLoading: sectionIsloading }: ResType = useQuery(
    ["excel-e-proceedings-sections"],
    getFyaSections,
    {
      onSuccess: (res) => {
        setSectionData(res?.data);
      },
    }
  );

  const { data: profiledata, isLoading: isprofileloading }: ResType = useQuery(
    ["get-income-tax-profile-name", params.incometaxid],
    getIncomeTaxProfileWithName
  );
  // const clientName = profiledata?.data?.profileDetails?.name;
  const { mutate: mutate1, isLoading: isExportLoading } = useMutation(exportClientproceedingFya, {
    onSuccess: (res: any) => {
      let clientName = res.data?.profileDetails?.name
      const arr = new Uint8Array(res.data?.buffer?.data);
      const blob = new Blob([arr], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const file = window.URL.createObjectURL(blob);
      let link = document.createElement("a");
      const formattedDateTime = getCurrentFormattedDateTime();
      link.href = file;
      link.download = `ATOM Pro - ${clientName} Income Tax (PAN) e-Proceedings (For Your Action) ${formattedDateTime}.xlsx`;
      link.click();
      snack.success("Income Tax (PAN) e-proceedings exported sucessfully");
    },
    onError: (err: any) => {
      snack.error(err);
      snack.error(handleError(err));
    },
  });

  const handleExport = () => {
    if (isExportLoading) return;
    mutate1({
      incometaxid: params.incometaxid,
      ...state,
    });
  };

  const [openFya, setOpenFya] = useState(false)
  const [editedData, setEditedData] = useState({})

  const columns: Array<ColumnType> = [
    {
      key: "assesmentYear",
      title: "Assessment Year",
      render: (v) => (
        <Typography
        >
          {generateAssessmentYear(v?.assesmentYear)}
        </Typography>
      ),
    },
    { key: "type", title: "Type" },

    {
      key: "noticeName",
      title: (
        <Box display="flex" alignItems="center">
          Section
        </Box>
      ),
      render: (v) => (
        <Typography
        >
          {v?.noticeName ? (
            <span
            >
              {v?.noticeName}
            </span>
          ) : (
            "--"
          )}
        </Typography>
      ),
    },
    {
      key: "sectionCodeText",
      title: "Proceeding Name",
      render: (v) => (
        <Typography
        >
          {v.proceedingName}
        </Typography>
      ),
    },
    {
      key: "",
      title: (
        <Box display="flex" alignItems="center">
          Assessee Name (PAN)
        </Box>
      ),
      render: (v) => {
        const displayName = (v?.type === "Other" && v?.notices[0]?.nameOfAssesse) ? v?.notices[0]?.nameOfAssesse : "--";
        return <Typography>{displayName} {v?.type === "Other" && (<span>{'(' + v?.pan + ')'}</span>)}</Typography>;
      },
    },
    {
      key: "proceedingOpenDate",
      title: "Proceeding Opened on",
      render: (v) => (
        <Typography
        >
          {v?.proceedingOpenDate ? moment(Number(v?.proceedingOpenDate)).format("DD-MM-YYYY HH:mm") : "-"}
        </Typography>
      ),
    },
    {
      key: "",
      title: "Actions",
      render: (rowData: any) => <Actions data={rowData} />,
    },

    {
      key: "id",
      title: "Created Type",
      render: (v) =>
        <Box>
          {v?.createdType === "MANUAL" ? (
            <StyledSpan bgColor="#f2e6ff">Manual</StyledSpan>
          ) : (
            <StyledSpan bgColor="#b3ecff">Portal</StyledSpan>
          )}
        </Box>
    },

  ];

  function Actions(props: any) {
    const navigate = useNavigate();

    const handleViewMoreClick = () => {
      navigate(`/atom-pro/income-tax/proceeding-action/${props.data?.id}`);
    };

    const handleEditClick = () => {
      setEditedData(props?.data)
      setOpenFya(true)
    };
    const conform = useConfirm()
    const queryClient = useQueryClient()

    const { mutate, isLoading } = useMutation(deleteFyaItem, {
      onSuccess: () => {
        snack.success("Fya Proceeding Deleted")
        queryClient.invalidateQueries("client-proceeding-fya")

      },
      onError: (error) => {
        snack.error(handleError(error))
      }
    })
    const handleDeleteClick = () => {
      conform({
        msg: "Are you sure want to delete this Proceeding?",
        action() {
          mutate({ id: props.data?.id })
        },
      })
    }

    return (

      <>
        <Box display="flex" gap={1}>
          <IconButton onClick={handleViewMoreClick} size="small">
            <Visibility />
          </IconButton>
          {props?.data?.createdType === "MANUAL" && (
            <>
              <IconButton onClick={handleEditClick} size="small">
                <Edit />
              </IconButton>
              <IconButton onClick={handleDeleteClick}>
                <Delete />
              </IconButton>
            </>
          )}

        </Box>
      </>
    );
  }

  const filterConfig = {
    assessmentYear: {
      label: "Assessment Year",
      type: "year",
      options: getAutFinancialYears(),
      getValue: (year) => year.split("-")[0],
    },
    section: {
      label: "Section",
      type: dropDownType.array,
      options: sections,
    },
    type: {
      label: "Type",
      type: dropDownType.array,
      options: ["Self", "Other"],
    },
  };

  const chips: any = buildChips(filters, filterConfig);
  
  const isFilterActive = hasActiveFilters(filters);


  if (isLoading) return <Loader />;
  return (
    <>
      <Box m={1}>
        {!checkAccess && <AccessDenied />}
        {checkAccess && (
          <>
            <Box mb={1} display="flex" justifyContent='space-between'>

              <SearchContainer
                debounced
                value={search}
                placeHolder="Search by Proceeding Name"
                onChange={handleSearch}
              />
              <Box>
                <ValidateAccess name={Permissions.CREATE_TASK}>
                  <Button>
                    <Link
                      to="/create-task"
                      state={{
                        clientDetails: {
                          label: clientDetails?.displayName,
                          value: clientDetails?.id,
                        },
                        isServiceOpen: true,
                        ...staticCategory,
                      }}
                    >
                      <Button variant="outlined" startIcon={<Add />}>
                        Task
                      </Button>
                    </Link>
                  </Button>
                </ValidateAccess>

                <Button
                  onClick={() => setOpenCreate(true)}
                  variant="outlined"
                  startIcon={<Add />}
                >
                  Proceeding
                </Button>

                <FilterEngine filters={filters} config={filterConfig} setFilters={setFilters} setPage={setPage} />
                {isFilterActive && (
                  <Tooltip title="Reset Filters">
                    <img
                      src={clearFilters}
                      alt="Reset"
                      style={{ cursor: "pointer", width: 38, height: 38 }}
                    onClick={() => {

                      setSearch("");
                      setFilters({
                        section: null,
                        assessmentYear: null,
                        type: null
                      })
                    }}
                  />
                </Tooltip>
                )}
                <Button>
                  <Tooltip title={isExportLoading ? "Exporting..." : "Data Export to Excel"}>
                    <img
                      src={excelIcon}
                      alt="Export"
                      style={{
                        cursor: isExportLoading ? "not-allowed" : "pointer",
                        width: 30,
                        height: 30,
                        opacity: isExportLoading ? 0.5 : 1,
                        transition: "opacity 0.2s ease",
                      }}
                      onClick={handleExport}
                    />
                  </Tooltip>
                </Button>

              </Box>
            </Box>
            <Box>
              <Stack direction="row" spacing={1} sx={{ mb: 1, ml: 2, mt: 1, flexWrap: "wrap" }}>
                {chips.map((chip) => (
                  <Chip
                    key={chip.key}
                    label={chip.label}
                    onDelete={() => {
                      const updated = { ...filters, [chip.key]: "" };
                      setFilters(updated);
                    }}
                    variant="outlined"
                    color="primary"
                  />
                ))}
              </Stack>
            </Box>



            <Table
              sx={{ pb: 0, mb: 0, height: "440px" }}
              pagination={{ totalCount, pageCount, setPageCount, page, setPage }}
              data={data?.data?.result || []}
              columns={columns}
              loading={isLoading}
            />
          </>
        )}
      </Box>
      <CreateClientFya open={openCreate} setOpen={setOpenCreate} profiledata={profiledata} />
      <EditClientFya open={openFya} setOpen={setOpenFya} data={editedData} clientName={profiledata?.data?.profileDetails?.name} />
    </>
  );
};

const generateAssessmentYear = (assessmentYear) => {
  if (!assessmentYear || assessmentYear === "0" || assessmentYear === "") {
    return "NA";
  } else if (!isNaN(assessmentYear) && assessmentYear.length === 4) {
    const year = parseInt(assessmentYear);
    const nextYear = (year + 1).toString().slice(-2);
    return `AY ${year}-${nextYear}`;
  } else {
    return assessmentYear;
  }
};






export default ClientEproceedingFya;
